module.exports = __webpack_public_path__ + "media/images/flags/BB-ff6c28a3cb5ee959620838b3319cfa30.svg";